/* ==========================================================================
   HM UI  —  panel (nav / cart drawer) open-close, scroll lock, size-select.
   Cart AJAX lives in hm-cart.js. Exposes window.HM.openPanel / closePanel.
   ========================================================================== */
(function () {
  "use strict";
  var doc = document, body = doc.body, openCount = 0;

  function panel(name) { return doc.getElementById("hm-" + name); }
  function scrim() { return doc.querySelector("[data-hm-scrim]"); }
  function lock(on) { openCount = Math.max(0, openCount + (on ? 1 : -1)); body.style.overflow = openCount > 0 ? "hidden" : ""; }

  function open(name) {
    var p = panel(name), s = scrim();
    if (!p) return;
    p.classList.add("is-open");
    p.setAttribute("aria-hidden", "false");
    if (s) s.classList.add("is-open");
    lock(true);
    var f = p.querySelector("[data-hm-close], a, button, input");
    if (f) f.focus();
  }

  function closeAll() {
    var o = doc.querySelectorAll(".hm-nav.is-open, .hm-drawer.is-open");
    if (!o.length) return;
    o.forEach(function (p) { p.classList.remove("is-open"); p.setAttribute("aria-hidden", "true"); });
    var s = scrim(); if (s) s.classList.remove("is-open");
    body.style.overflow = ""; openCount = 0;
  }

  doc.addEventListener("click", function (e) {
    var opener = e.target.closest("[data-hm-open]");
    if (opener) { e.preventDefault(); open(opener.getAttribute("data-hm-open")); return; }

    if (e.target.closest("[data-hm-close]") || e.target.hasAttribute("data-hm-scrim")) {
      e.preventDefault(); closeAll(); return;
    }

    // Size selection (PDP): single-select within a [data-hm-chips] group
    var chip = e.target.closest("[data-hm-chips] .hm-chip");
    if (chip && !chip.disabled) {
      var g = chip.closest("[data-hm-chips]");
      g.querySelectorAll(".hm-chip").forEach(function (c) {
        var on = c === chip;
        c.classList.toggle("is-selected", on);
        c.setAttribute("aria-pressed", on ? "true" : "false");
      });
      g.dispatchEvent(new CustomEvent("hm:sizechange", { bubbles: true, detail: { variantId: chip.dataset.variantId || "" } }));
      return;
    }
  });

  doc.addEventListener("keydown", function (e) { if (e.key === "Escape") closeAll(); });

  window.HM = window.HM || {};
  window.HM.openPanel = open;
  window.HM.closePanel = closeAll;
})();

/* ---- Hero auto-advancing slideshow ---------------------------------------- */
(function () {
  var hero = document.querySelector("[data-hm-hero]");
  if (!hero) return;
  var slides = [].slice.call(hero.querySelectorAll(".hm-hero__slide"));
  var dotsWrap = hero.querySelector("[data-hm-hero-dots]");
  var prevBtn = hero.querySelector("[data-hm-hero-prev]");
  var nextBtn = hero.querySelector("[data-hm-hero-next]");

  // Only one slide: no controls, no rotation.
  if (slides.length < 2) {
    if (dotsWrap) dotsWrap.hidden = true;
    if (prevBtn) prevBtn.hidden = true;
    if (nextBtn) nextBtn.hidden = true;
    return;
  }

  var interval = parseInt(hero.getAttribute("data-hm-interval"), 10) || 6000;
  var i = 0, timer = null, dots = [];

  if (dotsWrap) {
    slides.forEach(function (s, idx) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "hm-hero__dot" + (idx === 0 ? " is-active" : "");
      b.setAttribute("aria-label", "Show slide " + (idx + 1));
      b.addEventListener("click", function () { go(idx); restart(); });
      dotsWrap.appendChild(b);
      dots.push(b);
    });
  }
  if (prevBtn) prevBtn.addEventListener("click", function () { go(i - 1); restart(); });
  if (nextBtn) nextBtn.addEventListener("click", function () { go(i + 1); restart(); });

  function go(n) {
    slides[i].classList.remove("is-active");
    if (dots[i]) dots[i].classList.remove("is-active");
    i = (n + slides.length) % slides.length;
    slides[i].classList.add("is-active");
    if (dots[i]) dots[i].classList.add("is-active");
  }
  function start() {
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    timer = setInterval(function () { go(i + 1); }, interval);
  }
  function stop() { if (timer) { clearInterval(timer); timer = null; } }
  function restart() { stop(); start(); }

  start();
  document.addEventListener("visibilitychange", function () { if (document.hidden) stop(); else restart(); });
})();
